const FILE_SERVER_HOST = 'https://file.stemi.education/api/v1';

type Init<B> = Omit<RequestInit, 'body'> & { rawBody?: boolean; body?: B };

export const api = async <T, B = any>(
  url: string,
  rawInit: Init<B>,
  token?: string,
): Promise<T> => {
  const { rawBody, body, ...init } = rawInit || {};
  const res = await fetch(`${FILE_SERVER_HOST}${url}`, {
    ...init,
    ...(body && {
      body: rawBody ? (body as any) : JSON.stringify(body || {}),
    }),
    headers: new Headers({
      'content-type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw data;
  }

  return data;
};

export default api;
